import _ from 'lodash';
import { getField, updateField } from 'vuex-map-fields';
const state = {
    liquidacionForm: {
        isImpuesto: false,
        valor: 0
    },
    impuestos: [
        {
            year: 0,
            price: 0
        }
    ],
    gastos: {
        derechos: 0,
        retefuente: 0,
        prenda: 0,
        pignoracion: 0,
        impuestos: 0,
        cert_tradicion: 0,
        multas: 0,
        honorarios: 0,
        peritaje: 0,
        alistamiento: 0,
    },
    comprador: {
        cp_derechos: 0,
        cp_pignoracion: 0,
        cp_impuestos: 0,
        cp_cert_tradicion: 0,
        cp_honorarios: 0,
        cp_peritaje: 0,
        cp_alistamiento: 0
    },
    vendedor: {
        vd_derechos: 0,
        vd_retefuente: 0,
        vd_prenda: 0,
        vd_impuestos: 0,
        vd_cert_tradicion: 0,
        vd_multas: 0,
        vd_honorarios: 0,
        vd_alistamiento: 0
    },
    notSave: {
        precio_venta: 0,
        comision: 0,
        paga_iva: false 
    },
    newTable: {
        iva_comision: 0
    }
};
const mutations = {
    updateField,
    updateGastos: (state, payload) => {
        if (payload.transito !== null) {
            var gastos_traspaso = payload.transito.gastos_traspaso;
            state.gastos.cert_tradicion += gastos_traspaso.certificado_tradicion;
            state.gastos.derechos += gastos_traspaso.derechos_traspaso;
            state.gastos.honorarios += gastos_traspaso.honorarios;
            state.gastos.prenda += gastos_traspaso.levantamiento_prenda;
            state.gastos.pignoracion += gastos_traspaso.pignoracion;
        }
        if (payload.inspeccion_legal) {
            state.gastos.multas = payload.inspeccion_legal.vr_multas;
            state.gastos.peritaje = 220000;
            state.gastos.alistamiento = 200000;
        }
        var size = Object.keys(payload.gastos_traspaso).length;
        if (size > 0) {
            state.gastos = payload.gastos_traspaso.gastos;
            state.comprador = payload.gastos_traspaso.comprador;
            state.vendedor = payload.gastos_traspaso.vendedor;
            state.impuestos = payload.gastos_traspaso.impuestos;
            state.liquidacionForm = payload.gastos_traspaso.liquidacionForm;
        }
    },
    updateFromRequest: (state, payload) => {
        var gastos_traspaso = payload.transito.gastos_traspaso;
        state.gastos = {
            ...state.gastos,
            cert_tradicion: gastos_traspaso.certificado_tradicion,
            derechos: gastos_traspaso.derechos_traspaso,
            honorarios: gastos_traspaso.honorarios,
            prenda: gastos_traspaso.levantamiento_prenda,
            pignoracion: gastos_traspaso.pignoracion
        };
    },
    updateFromFichaTecnica: (state, payload) => {
        if (payload.inspeccion_legal) {
            state.gastos.multas = payload.inspeccion_legal.vr_multas;
        }
        if (payload.traspaso !== null) {
            var gastos_traspaso = payload.transito.gastos_traspaso;
            state.gastos.cert_tradicion = gastos_traspaso.certificado_tradicion;
            state.gastos.derechos = gastos_traspaso.derechos_traspaso;
            state.gastos.honorarios = gastos_traspaso.honorarios;
            state.gastos.prenda = gastos_traspaso.levantamiento_prenda;
            state.gastos.pignoracion = gastos_traspaso.pignoracion;
        }
    },
    addImpuestos: (state, payload) => {
        state.impuestos.push(payload);
    },
    removeImpuestos: (state, payload) => {
        state.impuestos.splice(payload, 1);
    },
    saveImpuestos: (state, payload) => {
        state.impuestos = payload;
    },
    changeYear: (state, payload) => {
        var impuesto = state.impuestos[payload.index];
        impuesto.year = payload.value;
        Object.assign(state.impuestos[payload.index], impuesto);
    },
    changePrice: (state, payload) => {
        var impuesto = state.impuestos[payload.index];
        impuesto.price = payload.value;
        Object.assign(state.impuestos[payload.index], impuesto);
    }
};

const getters = {
    getField
};

const actions = {

};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
